export default "__VITE_ASSET__6db2a73f__"